import FAQ from "@/data/faq.yml";
import INTRO from "@/data/faq-intro.yml";
import ContentBlock from "@/components/content-block";
import Expander from "@/components/Expander";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  components: { ContentBlock, Expander },
  data() {
    return {
      FAQ,
      INTRO,
    };
  },
};
